import { TextArea as HeroTextArea, type TextAreaProps as HeroTextAreaProps } from '@heroui/react';
import { cn } from '@/lib/utils';

export type TextAreaProps = HeroTextAreaProps & { isDisabled?: boolean };

export function TextArea({ className, disabled, isDisabled, ...props }: TextAreaProps) {
  return (
    <HeroTextArea
      className={cn(
        'w-full rounded-xl border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground shadow-none transition-colors focus:border-brand-500 focus:outline-none',
        className,
      )}
      disabled={disabled ?? isDisabled}
      {...props}
    />
  );
}
